import { defineMessages } from 'react-intl';

const messages = defineMessages({
  'general.status.pending': {
    id: 'OA_myOrders_state_pending',
    defaultMessage: 'En curso',
  },
  'general.status.cancelled': {
    id: 'OA_myOrders_state_cancelled',
    defaultMessage: 'Cancelados',
  },
  'general.status.delivered': {
    id: 'OA_myOrders_state_delivered',
    defaultMessage: 'Entregados',
  },
  'emptyState.noOrders.title': {
    id: 'OA_myOrder_fullScreen_emptyState_title_noOrders',
    defaultMessage: 'Aún no has realizado pedidos',
  },
  'emptyState.noOrders.description': {
    id: 'OA_myOrder_fullSCreen_emptyState_description_noOrders',
    defaultMessage: 'Busca entre todas nuestras opciones y disfruta de tu primer pedido.',
  },
  'emptyState.noOrders.makeOrder': {
    id: 'OA_myOrder_fullSCreen_emptyState_button_makeOrder',
    defaultMessage: 'Hacer pedido',
  },
  'navbar.title': {
    id: 'OA_myOrder_navbar_title',
    defaultMessage: 'Mis pedidos',
  },
  'month.format': {
    id: 'OA_myOrders_date_month_format',
    defaultMessage: '{day} de {month}',
  },
  'hour.format': {
    id: 'OA_myOrders_date_hours_format',
    defaultMessage: '{hour}:{minute} hs',
  },
  'card.state.pending': {
    id: 'OA_myOrders_card_state_pending',
    defaultMessage: 'En curso',
  },
  'card.state.delivered': {
    id: 'OA_myOrders_card_state_delivered',
    defaultMessage: 'Entregado',
  },
  'card.state.cancelled': {
    id: 'OA_myOrders_card_state_cancelled',
    defaultMessage: 'Cancelado',
  },
  'card.state.queued': {
    id: 'current_orders_v2_queued_status',
    defaultMessage: 'Programado',
  },
  'card.state.cancelled_by_vendor': {
    id: 'OA_myOrders_card_state_cancelled_by_vendor',
    defaultMessage: 'Cancelado por el local',
  },
  'card.openTime.label': {
    id: 'OA_myOrders_card_openTime_label',
    defaultMessage: 'Abre a las {openTime}',
  },
  'card.openTime.closed': {
    id: 'OA_myOrders_card_openTime_label_closed',
    defaultMessage: 'Cerrado por hoy',
  },
  'period.lastWeek': {
    id: 'OA_myOrders_filter_page_period_lastWeek',
    defaultMessage: 'Última semana',
  },
  'period.fifteenDaysAgo': {
    id: 'OA_myOrders_filter_page_period_fifteenDaysAgo',
    defaultMessage: 'Últimos 15 días',
  },
  'period.thirtyDaysAgo': {
    id: 'OA_myOrders_filter_page_period_thirtyDaysAgo',
    defaultMessage: 'Últimos 30 días',
  },
  'period.threeMonthsAgo': {
    id: 'OA_myOrders_filter_page_period_threeMonthAgo',
    defaultMessage: 'Últimos 3 meses',
  },
  'period.sixMonthsAgo': {
    id: 'OA_myOrders_filter_page_period_sixMonthAgo',
    defaultMessage: 'Últimos 6 meses',
  },
  'emptyState.noOrders.withCurrent.title': {
    id: 'OA_myOrder_fullScreen_emptyState_title_noOrders_withCurrent',
    defaultMessage: 'Tu primer pedido está en curso',
  },
  'emptyState.noOrders.withCurrent.description': {
    id: 'OA_myOrder_fullSCreen_emptyState_description_noOrders_withCurrent',
    defaultMessage: 'Lo verás aquí cuando sea entregado.',
  },
  'emptyState.noOrders.withCurrent.cancelled.title': {
    id: 'OA_myOrder_fullScreen_emptyState_title_noOrders_withCurrent_cancelled',
    defaultMessage: '¡Todo viene bien!',
  },
  'emptyState.noOrders.withCurrent.cancelled.description': {
    id: 'OA_myOrder_fullSCreen_emptyState_description_noOrders_withCurrent_cancelled',
    defaultMessage: 'No tienes pedidos cancelados.',
  },
  'emptyState.noOrders.withCurrent.filtered_empty.title': {
    id: 'OA_myOrder_fullScreen_emptyState_title_noOrders_withCurrent_filtered_empty',
    defaultMessage: 'No encontramos pedidos para estos filtros',
  },
  'emptyState.noOrders.withCurrent.filtered_empty.description': {
    id: 'OA_myOrder_fullSCreen_emptyState_description_noOrders_withCurrent_filtered_empty',
    defaultMessage: 'Por favor, limpialos y probá con otros.',
  },
  'emptyState.noOrders.withCurrent.button.clearFilters': {
    id: 'OA_myOrder_fullSCreen_emptyState_noOrders_withCurrent_button_clearFilters',
    defaultMessage: 'Limpiar filtros',
  },
  titleError: {
    id: 'OA_myOrder_fullSCreen_error_global_title',
    defaultMessage: 'Tuvimos un problema',
  },
  subTitleError: {
    id: 'OA_myOrder_fullSCreen_error_global_description',
    defaultMessage: 'Parece que no podemos atender tu solicitud en este momento.',
  },
  buttonLabelError: {
    id: 'OA_myOrder_fullSCreen_error_global_button_cta',
    defaultMessage: 'Ir al inicio',
  },
  'filters_advanced.apply.button': {
    id: 'OA_myOrders_filter_page_apply',
    defaultMessage: 'Aplicar',
  },
  'filters_advanced.title': {
    id: 'OA_myOrders_filter_page_title',
    defaultMessage: 'Filtrar por',
  },
  'filters_advanced.clear': {
    id: 'OA_myOrders_filter_page_clear',
    defaultMessage: 'Limpiar filtros',
  },
  products_quantity: {
    id: 'OA_myOrders_card_products_quantity',
    defaultMessage: '{products, plural, =0 {0 productos} one {# producto} other {# productos}}',
  },
  'vendorDetail.deliveryTime': {
    id: 'OA_myOrders_vndorDetail_delivery_time',
    defaultMessage: '{min} - {max} min',
  },
  'repeatOrder.outofzone.title': {
    id: 'OA_myOrders_repeatOrder_modal_title',
    defaultMessage: 'Fuera de la zona de cobertura',
  },
  'repeatOrder.outofzone.description': {
    id: 'OA_myOrders_repeatOrder_modal_description',
    defaultMessage: 'Esta dirección está fuera del rango posible de entrega',
  },
  'repeatOrder.general_error.modal.title': {
    id: 'OA_myOrders_repeatOrder_error_modal_title',
    defaultMessage: 'Problemas al repetir tu pedido',
  },
  'repeatOrder.general_error.modal..description': {
    id: 'OA_myOrders_repeatOrder_error_modal_description',
    defaultMessage:
      'En estos momentos estamos teniendo problemas para repetir tu pedido, vuelve a intentarlo mas tarde',
  },
  'repeatOrder.fullPage.selectAddress': {
    id: 'OA_myOrders_repeatOrder_fullPage_selectAddress',
    defaultMessage: 'Selecciona una de tus direcciones',
  },
  'repeatOrder.vendorDetail.product.title': {
    id: 'OA_myOrders_repeatOrder_vendorDetail_product',
    defaultMessage: 'Productos',
  },
  'general.label.ok': {
    id: 'OA_myOrders_general_label_ok',
    defaultMessage: 'Ok',
  },
  'couchmark.title': {
    id: 'OA_myOrders_couchmark_title',
    defaultMessage: '¡Retoma tu carrito!',
  },
  'couchmark.message': {
    id: 'OA_myOrders_couchmark_message',
    defaultMessage: 'Tu pedido de {vendorName} te espera.',
  },
  'filters.title': {
    id: 'OA_myOrders_filters_title',
    defaultMessage: 'Filtros',
  },
  'orders.v2.helpcenter': {
    id: 'OA_myOrders_card_actions_button_help',
    defaultMessage: 'Ayuda',
  },
  'rating.opinion': {
    id: 'OA_myOrders_card_rate_opinion',
    defaultMessage: 'Tu opinión',
  },
  'orders.v2.repeat.action': {
    id: 'OA_myOrders_card_actions_button_repeat',
    defaultMessage: 'Repetir',
  },
  'orders.v2.rate.action': {
    id: 'OA_myOrders_card_actions_button_rate',
    defaultMessage: 'Opinar',
  },
  'orders.v2.error.general.title': {
    id: 'orders_v2_error_general_title',
    defaultMessage: 'No pudimos cargar el listado de pedidos',
  },
  'orders.v2.error.general.description': {
    id: 'orders_v2_error_general_description',
    defaultMessage: 'Entregar una experiencia increíble, siempre.',
  },
  'orders.v2.error.general.action': {
    id: 'orders_v2_error_general_action',
    defaultMessage: 'Volver a intentar',
  },
  'orders.v2.error.without.orders.title': {
    id: 'orders_v2_error_without_orders_title',
    defaultMessage: 'Aun no realizaste pedidos',
  },
  'orders.v2.error.without.orders.description': {
    id: 'orders_v2_error_without_orders_description',
    defaultMessage: 'Busca entre todas nuestras opciones y disfruta de tu primer pedido.',
  },
  'orders.v2.error.without.orders.action': {
    id: 'orders_v2_error_without_orders_action',
    defaultMessage: 'Hacer pedidos',
  },
  'orders.v2.error.without.orders.filters.title': {
    id: 'orders_v2_error_without_orders_filters_title',
    defaultMessage: 'No encontramos pedidos para estos filtros',
  },
  'orders.v2.error.without.orders.filters.description': {
    id: 'orders_v2_error_without_orders_filters_description',
    defaultMessage: 'Por favor, limpialos y prueba con otros',
  },
  'orders.v2.error.without.orders.filters.action': {
    id: 'orders_v2_error_without_orders_filters_action',
    defaultMessage: 'Limpiar filtros',
  },
  'orders.v2.history.orders_title': {
    id: 'orders_v2_history_orders_title',
    defaultMessage: 'Historial de pedidos',
  },
  'orders.v2.history.current_title': {
    id: 'orders_v2_history_current_title',
    defaultMessage:
      '{count, plural, =0 {Tu primer pedido está en curso} one {Tu primer pedido está en curso} other {Tus # pedidos estan en curso}}',
  },
  'orders.v2.history.current_description': {
    id: 'orders_v2_history_current_description',
    defaultMessage: 'Lo verás aqui cuando se entregado.',
  },
  'orders.v2.history.plus_savings': {
    id: 'orders_v2_history_plus_savings',
    defaultMessage: 'Ahorraste {amount}',
  },
  'orders.v2.withoutCost': {
    id: 'orders_v2_withoutCost',
    defaultMessage: 'Sin costo',
  },
  'orders.v2.redelivery': {
    id: 'orders_v2_redelivery_products',
    defaultMessage:
      '{products, plural, =0 {Reenvío de 0 productos} one {Reenvío de # producto} other {Reenvío de # productos}}',
  },
});

export default messages;
